import SectionHead from "./SectionHead";
import { responses } from "@/mocks/social";

const stance: Record<string, string> = {
  defend: "bg-primary-100 text-primary-700",
  deny: "bg-accent-100 text-accent-800",
  hot: "bg-secondary-100 text-secondary-800",
};

export default function Responses() {
  return (
    <section id="responses" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-10 md:px-6 md:py-16">
        <SectionHead
          no="05"
          kicker="当事人回应 · 原声"
          title="每一方的说法，原样摆上来"
          sub="事件各方先后发声，口径存在分歧。编辑部只转述、不替任何一方定性，争议点单列待核实。"
        />

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-5">
          {responses.map((r) => (
            <figure
              key={r.speaker + r.time}
              className="relative flex h-full flex-col overflow-hidden rounded-lg border border-secondary-200 bg-background-100 p-5 md:p-6"
            >
              <span className="pointer-events-none absolute -right-1 top-2 font-heading text-[88px] font-black leading-none text-secondary-200/70 select-none">
                ”
              </span>
              <div className="relative mb-4 flex items-center gap-3">
                <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-foreground-950 font-heading text-sm font-bold text-background-50">
                  {r.speaker.charAt(0)}
                </span>
                <div className="min-w-0">
                  <p className="truncate text-sm font-bold text-foreground-950">{r.speaker}</p>
                  <p className="flex items-center gap-1.5 text-[11px] text-secondary-500">
                    {r.role} · {r.time}
                  </p>
                </div>
                <span className={`ml-auto whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-semibold ${stance[r.tone]}`}>
                  {r.status}
                </span>
              </div>
              <blockquote className="font-heading relative flex-1 text-lg font-medium leading-8 text-foreground-900">
                {r.quote}
              </blockquote>
              <figcaption className="relative mt-4 flex items-center gap-3 border-t border-secondary-200 pt-3 text-[11px] text-secondary-500">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-checkbox-circle-line text-primary-600" />
                  转述自公开渠道
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-shield-check-line" />
                  原文可查证
                </span>
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="mt-4 flex flex-col items-start justify-between gap-3 rounded-lg border border-dashed border-secondary-300 bg-background-100 px-4 py-3 text-xs text-secondary-600 sm:flex-row sm:items-center">
          <span className="inline-flex items-center gap-2">
            <i className="ri-alarm-warning-line text-accent-600" />
            口径分歧点：节目组称「音频经拼接」，爆料方晒「两版稿本」佐证，结论以第三方鉴定为准。
          </span>
          <a href="#community" className="inline-flex shrink-0 items-center gap-1 font-semibold text-primary-600 hover:underline">
            去讨论区表态
            <i className="ri-arrow-right-line text-sm" />
          </a>
        </div>
      </div>
    </section>
  );
}